export default "__VITE_ASSET__DNO32Bih__"